<template>
  <div class="col-md-12 mx-auto">
      <b-row>
          <b-col md="3">
            <b-list-group class="border-0 shadow-sm">
                <b-list-group-item active-class="active" to="/user/agent/profile">Home</b-list-group-item>
                <b-list-group-item active-class="active" to="/user/agent/activities/recent">Recent Activities</b-list-group-item>
                <!-- <b-list-group-item active-class="active" to="/user/agent/settings">Settings</b-list-group-item> -->
            </b-list-group>
          </b-col>
          <b-col>
              <b-card class="border-0 shadow-sm">
                  <router-view></router-view>
              </b-card>
          </b-col>
      </b-row>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>